<template>
  <v-container id="wrapper" class="seller-layout" fluid>
    <SellerNavbar></SellerNavbar>
    <router-view />
    <!-- <div class="push"></div> -->
    <sellerFooterComponent></sellerFooterComponent>
    <v-container>
      <v-row>
        <v-col></v-col>
        <v-col class="text-center">
          <p class="textcenter copyWrite-text">
            {{ $t("©2020 Mothaber. All rights reserved.") }}
          </p>
          <img src="../assets/images/payments.png" alt="" width="200px"
        /></v-col>
        <v-col>
          <div class="shifterlogo">
            <v-img
              src="../assets/shifters-logo.png"
              class="v-image-ltl"
              alt=""
              width="250px"
              :class="locale == 'en' ? 'v-image-ltr' : 'v-image-rtl'"
            />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import sellerFooterComponent from "../components/sellerFooter";
import SellerNavbar from "../components/SellerNavbar";

export default {
  components: { sellerFooterComponent, SellerNavbar },

  name: "SellerLayout"
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 !important;

  .copyWrite-text {
    color: #13a8b1;
  }

  .shifterlogo {
    position: relative;

    .v-image-ltr {
      position: absolute;
      right: 0;
    }

    .v-image-rtl {
      position: absolute;
      left: 0;
    }
  }
}

@media (min-width: 600px) {
  #wrapper {
    min-height: 100%;

    /* Equal to height of footer */
    /* But also accounting for potential margin-bottom of last child */
    margin-bottom: -175px;
  }

  .push {
    height: 175px;
  }
}
</style>
